// Copyright (c) 2016 Deere & Company

import {getDefaultState} from '../state/formatting';

export default (state = getDefaultState()) => state;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/reducers/formatting.js